import React from 'react';
import { Box } from '@mui/material';

interface LoadingOverlayProps {
  /** Steuert, ob der Lade-Zustand aktiv ist */
  isLoading: boolean;
  children: React.ReactNode;
}

/**
 * Generischer Lade-Overlay für Sections und Anzeigekomponenten.
 *
 * Bei isLoading=true wird der Inhalt visuell gedimmt
 * (reduzierte Opacity + keine Pointer-Events).
 * Der Content bleibt sichtbar, um Layout-Shifts zu vermeiden.
 */
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading, children }) => {
  return (
    <Box
      sx={{
        transition: 'opacity 0.25s ease-in-out',
        opacity: isLoading ? 0.45 : 1,
        pointerEvents: isLoading ? 'none' : 'auto',
      }}
    >
      {children}
    </Box>
  );
};

export default LoadingOverlay;
